import { injectable } from 'inversify';
import { IStorageService } from '@workbench-stack/core';

@injectable()
export class StorageService implements IStorageService {
    constructor() {}

    public initialize(payload): Promise<void> {
        return;
    }

    public get(key, scope, fallbackValue?: string): string | undefined {
        return;
    }

    public getBoolean(key, scope, fallbackValue?: boolean): boolean {
        return;
    }

    public getInteger(key, scope, defaultValue?: number): number {
        return;
    }

    public store(key: string, value: string | boolean | number | undefined | null, scope): void {
    }

    public remove(key: string, scope): void {
    }

    public async migrate(toWorkspace): Promise<void> {
        throw new Error('Migrating storage is currently unsupported in Web');
    }

    public flush(): void {
    }

    public close(): void {
    }

    public dispose(): void {
    }
}
